import {
  Button,
  Container,
  Header,
  SpaceBetween,
} from '@cloudscape-design/components';
import { useContext, useEffect, useState } from 'react';
import { IUser } from '../../models/interfaces';
import axios from 'axios';
import { UserContext } from '../../context/authContext';
import { UserRow } from './ManageUserRow';

export const ManageUsers = () => {
  const [users, setUsers] = useState<IUser[]>([]);
  const { auth } = useContext(UserContext);
  const getUsers = async () => {
    const results = await axios.get(
      `${process.env.REACT_APP_API}/getallusers`,
      auth
    );
    if (results.status === 200) {
      setUsers(results.data);
    }
  };

  const forcePasswordReset = async (id: string, password: string, isAdmin: boolean) => {
    console.log('runnning reset password')
    const results = await axios.put(
      `${process.env.REACT_APP_API}/resetpassword`,
      { userToReset: id, newPassword: password, isAdmin: isAdmin },
      auth
    );
    if(results.status === 204) {
      console.log('result from password reset', results)
    } else {
      console.log('error', results)
    }
  };

  useEffect(() => {
    getUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addUser = () => {
    const tempUser = {
      _id: '',
      username: '',
      name: '',
      password: null
    };
    const tempUserArray = users;
    tempUserArray.push(tempUser);
    setUsers([...tempUserArray]);
  };
  const saveUserSignup = async(username: string, name: string, password: string, isAdmin: boolean) => {
     const results = await axios.post(
       `${process.env.REACT_APP_API}/signup`,
       { username, name, password, isAdmin },
       auth
     );
     if (results.status === 204) {
       console.log('result from create user', results);
     } else {
       console.log('error', results);
     }
  }

  const updateUser = async(username: string, name: string, isAdmin: boolean) => {
      try{
        const results = await axios.put(
          `${process.env.REACT_APP_API}/updateUser`,
          { username, name, isAdmin },
          auth
        );
          console.log(results)
      } catch(e) {
        console.log("error from update", e);
      }
      
  }
  return (
    <Container
      header={
        <Header
          actions={
            <SpaceBetween direction="horizontal" size={'s'}>
              {/* <Button>Save</Button> */}
              <Button onClick={() => addUser()}>Add User</Button>
            </SpaceBetween>
          }
        >
          Manage Users
        </Header>
      }
    >
      {users.length > 0
        ? users.map((user) => {
            return (
              <UserRow user={user} forcePasswordReset={forcePasswordReset} saveUser={saveUserSignup} updateUser={updateUser} />
            );
          })
        : null}
    </Container>
  );
};
